import styled from "styled-components";

import { Input, ValidationState } from "../shared-style";

export const StyledInput = styled.input`
    ${Input}
    ${ValidationState}
`;
